import React from "react";

import { CloseIcon, SearchIcon } from "shared/ui/icons";

import { Clear, Icon, Input, Wrap } from "./styles";

interface SearchInputProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    // small — компактный вариант для плотных мест (поиск внутри карточки-сайдбара).
    size?: "medium" | "small";
    className?: string;
}

// Отдельный примитив, а не TextInput: у того нет префикса, а суффикс некликабельный.
export const SearchInput = ({
    value,
    onChange,
    placeholder,
    size = "medium",
    className,
}: SearchInputProps) => (
    <Wrap className={className}>
        <Icon $size={size}>
            <SearchIcon />
        </Icon>
        <Input
            value={value}
            placeholder={placeholder}
            $size={size}
            onChange={(event) => onChange(event.target.value)}
        />
        {value.length > 0 && (
            <Clear type="button" aria-label="Очистить" onClick={() => onChange("")}>
                <CloseIcon />
            </Clear>
        )}
    </Wrap>
);
